import { useContext } from "react";

import IRecordStylingContext from "../types/IRecordStylingContext";

import RecordStylingContext from "./RecordStylingContext";

const useRecordStylingContext = (): IRecordStylingContext => {
  return useContext(RecordStylingContext) as unknown as IRecordStylingContext;
};

export default useRecordStylingContext;
